/* Style the slide's own Text block as a stat row.

   Nothing is injected: the theme renders the block, so it inherits the slide's
   alignment and padding and cannot drift out of the container. We only rewrite
   what is inside it.

   Authoring format, in the Text block:
     26+ Countries Served | 194+ Fragrances | 4.9 Google Rating
   First token of each part is the value, the rest the label.

   A flex row left-packs whatever the block's text-align says, so the computed
   alignment is read BEFORE rewriting and mirrored onto justify-content. */
(function () {
  var RE = /^\s*([^\s]+(?:\s?\+)?)\s+(.+)$/;

  function build(el) {
    if (el.dataset.croStat) return;
    var raw = (el.textContent || '').trim();
    if (raw.indexOf('|') < 0) return;

    var parts = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length < 2) return;

    var align = (window.getComputedStyle(el).textAlign || 'start');

    el.innerHTML = parts.map(function (p) {
      var m = p.match(RE);
      return '<span class="cro-stat"><b>' + (m ? m[1] : p) + '</b><i>' +
             (m ? m[2] : '') + '</i></span>';
    }).join('');

    el.classList.add('cro-statline');
    if (align === 'center') el.classList.add('cro-statline--c');
    if (align === 'right' || align === 'end') el.classList.add('cro-statline--r');
    el.dataset.croStat = '1';
  }

  function run() {
    var els = document.querySelectorAll('.hdt-slideshow__slide .hdt-text-base, .hdt-slideshow__slide .hdt-text-block, [data-cro-statline]');
    for (var i = 0; i < els.length; i++) build(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
